import { useState, useEffect } from 'react';
import { heroData } from '../../data/mock';
import { ChevronDown } from 'lucide-react';

export const HeroSection = () => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setLoaded(true), 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <section className="relative h-screen min-h-[700px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={heroData.backgroundImage}
          alt="Steel windows and doors"
          className={`w-full h-full object-cover hero-ken-burns ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
          style={{ transition: 'opacity 1.5s ease' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-[#0A0A0A]/40 to-[#0A0A0A]/90" />
      </div>

      <div className="relative z-10 h-full flex flex-col justify-center items-center text-center px-6">
        <p
          className={`text-[#E8D5A8] tracking-[0.5em] uppercase text-[12px] mb-6 transition-all duration-1000 delay-500 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ textShadow: '0 1px 20px rgba(0,0,0,0.8), 0 2px 40px rgba(0,0,0,0.5)' }}
        >
          {heroData.subtitle}
        </p>

        <h1
          className={`font-serif text-[clamp(2.8rem,7.5vw,8rem)] text-[#F5F1EC] leading-[0.9] mb-5 transition-all duration-1000 delay-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ textShadow: '0 2px 30px rgba(0,0,0,0.6), 0 4px 60px rgba(0,0,0,0.4)' }}
        >
          <span className="font-light">{heroData.titleLine1}</span>
          <br />
          <span className="italic font-medium">{heroData.titleLine2}</span>
        </h1>

        <p
          className={`text-[#D4C8B8] tracking-[0.4em] uppercase text-[12px] transition-all duration-1000 delay-[900ms] ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
          style={{ textShadow: '0 1px 20px rgba(0,0,0,0.8), 0 2px 40px rgba(0,0,0,0.5)' }}
        >
          {heroData.tagline}
        </p>
      </div>

      <div
        className={`absolute bottom-10 left-1/2 -translate-x-1/2 transition-opacity duration-1000 delay-[1400ms] ${
          loaded ? 'opacity-30' : 'opacity-0'
        }`}
      >
        <div className="scroll-bounce">
          <ChevronDown size={18} className="text-[#F5F1EC]" />
        </div>
      </div>
    </section>
  );
};
